<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />
    <CommissionsReport />
  </Layout>
</template>

<script>
import Layout from '@/views/Layout'
import CommissionsReport from '@/components/Reports/Commissions/CommissionsReport'

export default {
  name: 'ReportCommissionsView',
  components: {
    Layout,
    CommissionsReport
  },
  computed: {
    breadcrumbs: () => [
      {
        text: 'Início',
        to: { name: 'HomeIndex' }
      },
      {
        text: 'Relatórios',
        to: { name: 'ReportsIndex' }
      },
      {
        text: 'Comissões',
        to: { name: 'ReportCommissions' },
        active: true
      }
    ]
  }
}
</script>
